export enum OrderDocumentStatus {
    Uploaded = 1,
    Pending = 2
}